import { NgModule } from '@angular/core';
import { HeaderComponent } from './header.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    HeaderComponent
  ],
  imports: [
    TranslateModule,
    RouterModule,
    CommonModule,
    LocalizeRouterModule
  ],
  exports: [
    HeaderComponent
  ]
})

export class HeaderModule { }
